import type { Brand } from './types'

export const BRAND_FIELD_META: Record<
  keyof Brand,
  { label: string; kind: 'text' | 'color' | 'url'; hint?: string; placeholder?: string }
> = {
  name: { label: 'Brand name', kind: 'text' },
  primary: { label: 'Primary', kind: 'color' },
  primaryFg: { label: 'Primary foreground', kind: 'color' },
  accent: { label: 'Accent', kind: 'color' },
  accentFg: { label: 'Accent foreground', kind: 'color' },
  surface: { label: 'Surface', kind: 'color' },
  sidebar: { label: 'Sidebar', kind: 'color', placeholder: 'Default' },
  primaryDark: { label: 'Primary (dark)', kind: 'color' },
  primaryFgDark: { label: 'Primary foreground (dark)', kind: 'color' },
  accentDark: { label: 'Accent (dark)', kind: 'color' },
  accentFgDark: { label: 'Accent foreground (dark)', kind: 'color' },
  surfaceDark: { label: 'Surface (dark)', kind: 'color' },
  sidebarDark: { label: 'Sidebar (dark)', kind: 'color' },
  logoUrlLight: { label: 'Logo URL (light)', kind: 'url' },
  logoUrlDark: { label: 'Logo URL (dark)', kind: 'url' },
  logoAspect: { label: 'Logo aspect ratio', kind: 'text' },
  fontHeading: { label: 'Heading font', kind: 'text' },
  fontBody: { label: 'Body font', kind: 'text' },
}
